import { Link } from "react-router-dom";
import { AiFillEdit } from "react-icons/ai";

export function EditLink({ to = "", title = "Editar", onClick = () => {} }) {
  return (
    <Link to={to} className="btn btn-sm btn-warning" onClick={onClick}>
      <span>{title}</span>
      <AiFillEdit className="ms-1" />
    </Link>
  );
}
